import {http} from '@/http/index.js';

async function deleteVideo(videoId) {
  return http.delete(`/posts-videos/${videoId}`);
}

export {deleteVideo};
